import React, { ButtonHTMLAttributes, FC } from "react";
import clsx from "clsx";
interface Props {
  className?: string;
  border?: string;
  color?: string;
  children?: React.ReactNode;
  height?: string;
  onClick?: () => void;
  radius?: string;
  width?: string;
  fontSize?: string;
}

const Button = (Props: any) => {
  const { className, border, color, children, height, onClick, radius, width, fontSize, backgroundColor } = Props;

  return (
    <button
      className={clsx(className)}
      onClick={onClick}
      style={{
        backgroundColor,
        borderRadius: radius,
        height,
        width,
        color,
        fontSize,
      }}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  className: "primary-cta",
  children: "SAVE",
  height: "60px",
  radius: "38px",
  width: "176px",
  fontSize: "18px",
  onClick: () => null,
};

export default Button;
